<template>
	<div>
		<v-progress-circular
			v-if="$auth.loading"
			class="d-flex justify-center align-center"
      indeterminate
			:size="100"
			:width="10"
      color="secondary"
    ></v-progress-circular>
		
		<v-img
			:aspect-ratio="16/9"
			style="height: 94vh;"
			src="@/assets/main-login.jpg"
		>
		</v-img>
	</div>

</template>
<script>

  export default {
    name: 'Login',

		mounted () {
			if (this.$auth.loading === false) {
				if (this.$auth.isAuthenticated) {
					this.$router.push('/authenticated/dashboard');
				}
			} else {
				this.$auth.$watch('authRedirect', (loading) => {
					if (loading === false) {
						if (this.$auth.isAuthenticated) {
							this.$router.push('/authenticated/dashboard');
						}
					}
				})
			}
		}
  }
</script>
